import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function PayCODSuccess() {

    useEffect(() => {
        localStorage.removeItem("basket");
      }, []);

    return (
        <div className="container-lg p-0 d-flex flex-column flex-sm-row justify-content-center align-items-center my-5">
            <div className="text-center">
                <img
                    src="https://cdn-icons-png.flaticon.com/512/3500/3500833.png"
                    alt="COD Success"
                    width="100"
                    height="100"
                    className="mb-4"
                />
                <h2 className="mb-3 text-success">Rendelés sikeresen leadva!</h2>
                <p className="lead">
                    Köszönjük a rendelésed! A fizetés utánvéttel történik – <strong>futár esetén készpénzzel vagy bankkártyával</strong>, <strong>csomagautomatánál kizárólag bankkártyával</strong> tudsz fizetni az átvételkor.
                </p>

                <p>
                    A rendelés részleteit elküldtük az e-mail címedre, és hamarosan átadjuk a futárszolgálatnak.
                </p>
                <Link to="/" className="btn btn-home-primary mt-4">
                    Vissza a főoldalra
                </Link>
            </div>
        </div>
    );
}

export default PayCODSuccess;
